var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartadded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.128,
    height: 25.75,
    viewBox: "0 0 27.128 25.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_to_cart",
    "data-name": "add to cart",
    transform: "translate(0 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M8.5,19A1.5,1.5,0,1,0,10,20.5,1.5,1.5,0,0,0,8.5,19ZM19,16H7a1,1,0,0,1,0-2h8.491a3.013,3.013,0,0,0,2.885-2.176l1.585-5.549A1,1,0,0,0,19,5H6.739A3.007,3.007,0,0,0,3.921,3H3A1,1,0,0,0,3,5h.921a1,1,0,0,1,.961.725l.156.545v.005l1.641,5.742A3,3,0,0,0,7,18H19a1,1,0,0,0,0-2ZM17.674,7l-1.221,4.274a1,1,0,0,1-.962.726H8.754L8.5,11.108,7.326,7ZM16.5,19A1.5,1.5,0,1,0,18,20.5,1.5,1.5,0,0,0,16.5,19Z",
    transform: "translate(-2 6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 6.176,
    cy: 6.195,
    rx: 6.176,
    ry: 6.195,
    transform: "translate(13.027 2)",
    fill: "#b07f4a",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M2.7,81.585a.555.555,0,0,1-.394-.163L.188,79.3a.556.556,0,1,1,.787-.787L2.7,80.242l3.453-3.455a.556.556,0,1,1,.787.787L3.095,81.422A.555.555,0,0,1,2.7,81.585Z",
    transform: "translate(15.556 -71.096)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartadded);
export default __webpack_public_path__ + "static/media/cartadded.2b59b6aaf696042a429e6b41fad15c9e.svg";
export { ForwardRef as ReactComponent };